import { render, staticRenderFns } from "./ExpertiseAreaBlock.vue?vue&type=template&id=bad3f136"
import script from "./ExpertiseAreaBlock.vue?vue&type=script&lang=js"
export * from "./ExpertiseAreaBlock.vue?vue&type=script&lang=js"
import style0 from "./ExpertiseAreaBlock.vue?vue&type=style&index=0&id=bad3f136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports